"use client"

import { SectionHeadingWithoutStylingProps } from "@/src/components/section-heading/interface";
import { SectionHeading } from "@/src/components/section-heading";
import { PartnerCard, PartnerCardProps } from "@/src/components/cards/partner";
import { PartnerCardsCaraousl } from "./cards-carousel";
import { partnersSectionData_en } from "@/data/en/partner-section";
import { partnersSectionData_ar } from "@/data/ar/partner-section";
import { getStaggeredDelay } from "@/src/utils/set-staggered-delay";
import { Container } from "@/src/components/container";

export interface PartnerSectionProps {
  sectionHeading: SectionHeadingWithoutStylingProps;
  cards: PartnerCardProps[];
  params :{
    lang: string;
  }
}

export function PartnerSection({params}: PartnerCardProps) {
  const isArabic = params?.lang === "ar";
  const { sectionHeading, cards } = isArabic ? partnersSectionData_ar : partnersSectionData_en;
  return (
    <section className="section-padding-primary overflow-hidden">
      <Container>
        <div className="mx-auto max-w-[630px]">
          <div data-aos="fade-up" data-aos-delay="100">
            <SectionHeading
              {...sectionHeading}
              alignment="center"
              hasBottomSpacing
            />
          </div>
        </div>
        {cards && cards.length > 0 && (
          <div className="-mx-4 flex flex-wrap justify-center gap-y-30px">
            {cards.map((cards, index) => (
              <div
                key={index}
                data-aos="fade-up"
                data-aos-delay={getStaggeredDelay([200, 400, 600], index)}
                className="w-1/2 px-4 md:w-1/2 md:px-[15px] lg:w-2/12"
              >
                <PartnerCard {...cards} />
              </div>
            ))}
          </div>
        )}
      </Container>
    </section>
  );
}